//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { group} from "@/api/school";
import {mapState } from "vuex";
import formatter from "@/mixins/formatter"

export default {
    mixins:[formatter],
    data () {
        return{
            current_key:1,  //1按聊天记录查询,2按成员查询
            key_word:'',
            col_span:10,
         
            list:[],  //记录
            list1:[],//上下文
            chat_name:'',
            list_context:[],

            msg_list:[],
            cur_param:{msg_seq:0,},
            cur_mode:'Group',
            contentLoading:false,
            loading:true,
        }
    },

    computed: {
        ...mapState("user", ['innerHeight']),
    },

    components:{},
   
    methods:{
        nextContent(val){
            if(this.current_key==2){
                return
            }
            let len=this.list_context.length-1
            let cur=this.list_context[len]&&this.list_context[len].msg_seq?this.list_context[len].msg_seq+1:-1
            if(cur&&this.msg_list.findIndex(z=>z==cur)==-1){
                this.msg_list.push(cur)
                this.cur_param.msg_seq=cur
                this.cur_param.up=false
                this.getUpOrDownContents(this.cur_param,1)
            }
        },
        getUpOrDownContents(param,val,pagesize){
            if(param.msg_seq==-1){
                return
            }
            if(pagesize){
                param.num=pagesize
            }
            this.contentLoading=true
            param.is_admin=true
            let  promise=this.cur_mode=='Group'?group.getGroupContext(param):group.getContext(param)
            promise.then(res=>{
                this.contentLoading=false
                if(res.data){
                    let items=res.data.map(r=>{
                        return{
                            mode:r.mode,
                            msg_seq:r.msg_seq,
                            group_id:r.group?r.group.group_id:null,
                            group_name:r.group?r.group.name||'未命名群':null,
                            avatar:r.from_user?r.from_user.avatar:'',
                            from_user_name:r.from_user?r.from_user.namecard||r.from_user.nickname||r.from_user.name:'',
                            from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                            to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                            msg_body:this.markBadWord(r.msg_body),
                            add_time_str:this.timeForLimitTime(r.add_time)
                        }
                    })
                    this.list_context=val==1?this.list_context.concat(items):val==2?items.concat(this.list_context):items

                    let dom1=document.getElementById('chatListRef')
                    dom1.onscroll = (_r) => {

                        if(dom1.scrollTop==0){
                            let cur=this.list_context[0]&&this.list_context[0].msg_seq?this.list_context[0].msg_seq-1:0
                            if(cur&&this.msg_list.findIndex(z=>z==cur)==-1){
                                this.msg_list.push(cur)
                                this.cur_param.msg_seq=cur
                                this.cur_param.up=true
                                this.getUpOrDownContents(this.cur_param,2,5)
                            }
                        }
                    }
                }
            })
        },

        changeBy(val){
            this.current_key=val;
            this.list_context=[]
            this.chat_name=''
            this.getList()
        },
        toBack(){
            this.$router.go(-1)
        },

        getContents(item){
            this.chat_name=item.group_name;
            let param={
                group_id:item.group_id,
                msg_seq:item.msg_seq
            }
            this.contentLoading=true
            this.cur_mode=item.mode

            this.msg_list=[item.msg_seq]
            this.cur_param=param

            if(this.current_key==1){
                param.up=false
                this.getUpOrDownContents(param)
            }else{
                let promise=group.searchForMsg(param)
                promise.then(res=>{
                    this.contentLoading=false
                    if(res.data){
                        this.list_context=res.data.msg.map(r=>{
                            return{
                                mode:r.mode,
                                msg_seq:r.msg_seq,
                                group_id:r.group?r.group.group_id:null,
                                group_name:r.group?r.group.name||'未命名群':null,
                                avatar:r.from_user?r.from_user.avatar:'',
                                from_user_name:r.from_user?r.from_user.name:'',
                                from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                                to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                                to_im_user_name:r.to_user?r.to_user.name:null,
                                msg_body:r.msg_body?this.markBadWord(r.msg_body):[],
                                add_time_str:this.timeForLimitTime(r.add_time)
                            }
                        })
                    }else{
                        this.list_context=[];
                    }
                })
            }
        },
        getList(item){
            this.list_context=[]
            this.list=[]
            this.list1=[]
            this.chat_name=null
            if(!this.key_word){
                return
            }
            this.loading=true
            let param={key_word:this.key_word}
            group.search(param).then(res=>{
                this.loading=false
                if(res.data){
                    this.list=res.data.msg.map(r=>{
                        return{
                            mode:r.mode,
                            msg_seq:r.msg_seq,
                            group_id:r.group?r.group.group_id:null,
                            group_name:r.group?r.group.name||'未命名群':null,
                            avatar:r.from_user?r.from_user.avatar:'',
                            from_user_name:r.from_user?r.from_user.name:'',
                            from_im_user_id:r.from_user?r.from_user.im_user_id:null,
                            to_im_user_id:r.to_user?r.to_user.im_user_id:null,
                            to_im_user_name:r.to_user?r.to_user.name:null,
                            msg_body:this.markBadWord(r.msg_body),
                            add_time_str:this.timeForLimitTime(r.add_time)
                        }
                    })

                    this.list1=res.data.group.map(r=>{
                        return{
                            group_id:r.group_id,
                            group_name:r.name||'未定义群',
                            avatar:r.avatar,
                            owner_id:r.owner_id,
                            category:r.category=='O2O'?'家园一对一群':r.category=='Class'?'班级群':r.category=='Staff'?'全园群':'自定义群'
                        }
                    })
                }
            })
        },

        markBadWord(msg_body){
            if(!msg_body||msg_body.legnth==0){
                return []
            }
            msg_body.forEach(z=>{
                z.list=[]
                if(z.type=='TIMTextElem'){
                    let text_split=z.text.trim().split('')
                    text_split.forEach((c,n)=>{
                        let color=''
                        if(z.index&&z.index.length>0){
                            for (let i = 0; i < z.index.length; i++){
                                if(n>=z.index[i].start&&n<=z.index[i].end){
                                    color='#FF4A00'
                                    break
                                }
                            }
                        }
                        z.list.push({text:c,color:color})
                    })
                }else{
                    z.list=[{text:z.text,color:''}]
                }
            })
            return msg_body
        },
    },
    mounted(){
        this.key_word=this.$route.query.name;
        this.loading=false
        this.getList()
    }
}



// WEBPACK FOOTER //
// ./src/views/imChart/search.vue